'use strict';

/* globals config, $, socket */

require([
	config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
], function (Vue) {
	var internals = {};

	Vue.component('course-analytics-attempt', {
		props: ['initData', 'openUserAttempts', 'attempt'],
		template:
		'<div>' +
			'<div class="row">' +
				'<div class="col-sm-12 text-right">' +
					'<button class="btn btn-xs btn-primary" v-on:click="openUserAttempts()">Go back...</button>' +
				'</div>' +
			'</div>' +
			'<div class="row mt-2">' +
				'<table class="table table-bordered table-hover">' +
					'<thead>' +
						'<th>{{initData.translations.courseAnalyticsChapter}}</th>' +
						'<th>{{initData.translations.courseAnalyticsTotalVideoTime}}</th>' +
						'<th>{{initData.translations.courseAnalyticsReachedVideoEnd}}</th>' +
					'</thead>' +
					'<tbody>' +
						'<tr v-for="attempt in attempt.chaptersAttempts">' +
							'<td>{{attempt.chapter.title}}</td>' +
							'<td>{{attempt.chapterTotalTime}}</td>' +
							'<td>{{attempt.reachedEndOfVideo ? initData.translations.courseAnalyticsReached : initData.translations.courseAnalyticsNotReached}}</td>' +
						'</tr>' +
					'</tbody>' +
				'</table>' +
			'</div>' +
		'</div>',
	});
});
